import { useContext } from 'react';

import { ChatComposerFocusContext } from './ChatComposerFocusContext';
import { TChatComposerFocusContextValue } from './types';

/**
 * Returns the ChatComposerFocus context value, providing focusMessageInput().
 * Must be used within a ChatComposerFocusContext.Provider (rendered by ChatInput).
 */
const useChatComposerFocus = (): TChatComposerFocusContextValue => useContext(ChatComposerFocusContext);

export { useChatComposerFocus };
